import { ref, computed, reactive, defineComponent, toRefs, onMounted, watch } from "vue";
import { CloseOutlined } from "@ant-design/icons-vue";
import store from "@/store";
export default defineComponent({
  isGlobal: true,
  name: "DialogCommon",
  components: { CloseOutlined },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    dialogWidth: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmText:{
      type:String,
      default:'确定'
    },
    cancelText:{
      type:String,
      default:'取消'
    }
  },
  computed: {
    hasHeaderSlot() {
      return this.$slots.header && this.$slots.header().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasBodySlot() {
      return this.$slots.body && this.$slots.body().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasFooterSlot() {
      return this.$slots.footer && this.$slots.footer().findIndex((o) => o.type !== Comment) !== -1;
    },
  },
  emits: ["close", "ok", "update:dialogBodyHeight"],
  setup(props, { emit }) {
    const state = reactive({
      windowHeight: computed(() => {
        return store.state.user.windowSize.height;
      }),
      dialogHeight: computed(() => {
        return state.windowHeight * 0.8;
      }),
      dialogHeaderHeight: 55,
      dialogFooterHeight: props.showFooter ? 55 : 0,
      dialogBodyHeight: computed(() => {
        return state.dialogHeight - state.dialogHeaderHeight - state.dialogFooterHeight;
      }),
    });
    const close = () => {
      emit("close", "");
    };
    const ok = () => {
      emit("ok", "");
    };
    watch(
      () => state.dialogBodyHeight,
      (n, o) => {
        if (n) {
          emit("update:dialogBodyHeight", n);
        }
      },
      {
        immediate: true,
      }
    );
    return {
      CloseOutlined,
      close,
      ok,
      ...toRefs(state),
    };
  },
});
